import * as React from "react";
import { Button } from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { ReportFileInfo, MetricsService } from "gen/clients";

interface Props {
  reportId: string;
  csvFile: ReportFileInfo;
}

const ExportClientContactsReportButton: React.FC<Props> = ({ reportId, csvFile }) => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const handleExport = React.useCallback(async () => {
    try {
      setIsDownloading(true);

      // Get secure download URL
      const response = await MetricsService.downloadReportJobFile({
        reportId,
        s3Key: encodeURIComponent(csvFile.s3Key)
      });

      // Create a temporary link element and trigger download
      const link = document.createElement("a");
      link.href = response.downloadUrl;
      link.download = `client-contacts-report-${reportId}.csv`;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download report file:", error);
    } finally {
      setIsDownloading(false);
    }
  }, [reportId, csvFile.s3Key]);

  return (
    <Button variant="outlined" startIcon={<SaveAltIcon />} onClick={handleExport} disabled={isDownloading}>
      {isDownloading ? "Downloading..." : "Export CSV"}
    </Button>
  );
};

export { ExportClientContactsReportButton };
